import { Nav, Navbar } from 'react-bootstrap';
import { Social } from './social';
import Disclaimer from './Disclaimer'
import './Footer.scss'

const Footer = () => {
  return (
    <>
    <Disclaimer />
    <Navbar bg="dark" variant="dark" expand="lg" className="footer">
      
        <Social />
      
    </Navbar>
    </>
  )
}

export default Footer;